import axios from '@/libs/axios'

class CompetenciasService {
  /**
   * Obtener todas las competencias
   * @returns {Promise<Array>} - Lista de competencias
   */
  async getAll() {
    try {
      const response = await axios.get('/competencias')
      return response.data
    } catch (error) {
      console.error('Error al obtener competencias:', error)
      throw error
    }
  }

  /**
   * Obtener competencias por docente
   * @param {number} catedraticoId - ID del docente
   * @returns {Promise<Object>} - Competencias del docente
   */
  async getByCatedratico(catedraticoId) {
    try {
      const response = await axios.get(`/competencias/catedratico/${catedraticoId}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener competencias del docente:', error)
      throw error
    }
  }

  /**
   * Obtener cursos disponibles para asignar a un docente
   * @param {number} catedraticoId - ID del docente
   * @returns {Promise<Array>} - Lista de cursos disponibles
   */
  async getCursosDisponibles(catedraticoId) {
    try {
      const response = await axios.get(`/competencias/cursos-disponibles/${catedraticoId}`)
      return response.data
    } catch (error) {
      console.error('Error al obtener cursos disponibles:', error)
      throw error
    }
  }

  /**
   * Crear nueva competencia
   * @param {Object} competenciaData - Datos de la competencia
   * @returns {Promise<Object>} - Competencia creada
   */
  async create(competenciaData) {
    try {
      const response = await axios.post('/competencias', competenciaData)
      return response.data
    } catch (error) {
      console.error('Error al crear competencia:', error)
      throw error
    }
  }

  /**
   * Actualizar competencia
   * @param {number} id - ID de la competencia
   * @param {Object} competenciaData - Datos actualizados
   * @returns {Promise<void>}
   */
  async update(id, competenciaData) {
    try {
      await axios.put(`/competencias/${id}`, competenciaData)
    } catch (error) {
      console.error('Error al actualizar competencia:', error)
      throw error
    }
  }

  /**
   * Eliminar competencia (soft delete)
   * @param {number} id - ID de la competencia
   * @returns {Promise<void>}
   */
  async delete(id) {
    try {
      await axios.delete(`/competencias/${id}`)
    } catch (error) {
      console.error('Error al eliminar competencia:', error)
      throw error
    }
  }
}

export const competenciasService = new CompetenciasService()
